<template>
  <div class="page-form">
    <div class="page-form-title" v-if="title">{{ title }}</div>
    <div class="page-form-main">
      <el-form ref="form" :model="form" :rules="rules" @submit.stop.prevent.native="submit">
        <div class="page-form-main-item" v-for="(field, index) in fields" :key="index">
          <div class="page-form-main-item-label">
            <el-select v-if="Object.prototype.toString.call(field.label) === '[object Object]'" v-model="form[field.label.key]" :placeholder="field.label.placeholder">
              <el-option class="page-form-main-item-option" v-for="option in field.label.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>
            <span v-else>{{ field.label }}</span>
          </div>
          <el-input v-if="field.type === 'input'" v-model="form[field.key]" :placeholder="field.placeholder" :clearable="field.clearable"></el-input>
          <search-index v-else-if="field.type === 'person'" v-model="form[field.key]" :placeholder="field.placeholder"></search-index>
          <search-index v-else-if="field.type === 'address'" v-model="form[field.key]" :placeholder="field.placeholder" type="Address"></search-index>
          <!-- <el-select
            v-else-if="field.type === 'person'"
            v-model="form[field.key]"
            filterable
            remote
            reserve-keyword
            :placeholder="field.placeholder"
            :remote-method="remoteMethod(field)"
            :loading="personLoading"
            @visible-change="personVisibleChange($event, field)">
            <el-option
              v-for="item in personList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select> -->
          <!-- <el-select
            v-else-if="field.type === 'address'"
            v-model="form[field.key]"
            filterable
            remote
            reserve-keyword
            :placeholder="field.placeholder"
            :remote-method="addressMethod(field)"
            :loading="addressLoading"
            @visible-change="personVisibleChange($event, field)">
            <el-option
              v-for="item in addressList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select> -->
          <el-select class="page-form-select" v-else-if="field.type === 'select'" v-model="form[field.key]" :placeholder="field.placeholder" :clearable="field.clearable">
            <el-option class="page-form-main-item-option" v-for="option in field.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
          </el-select>
          <div class="page-form-main-item-group" v-else-if="field.type === 'selectGroup'">
            <el-select class="page-form-select" v-model="form[field.start.key]" :placeholder="field.start.placeholder" :clearable="field.clearable">
              <el-option class="page-form-main-item-option" v-for="option in field.start.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>
            <div class="page-form-main-item-group-separator">{{ field.separator || '~' }}</div>
            <el-select class="page-form-select" v-model="form[field.end.key]" :placeholder="field.end.placeholder" :clearable="field.clearable">
              <el-option class="page-form-main-item-option" v-for="option in field.end.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="page-form-main-item" v-if="fields.length">
          <el-button type="primary" @click.stop="search">{{ btnName }}</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import * as homeApi from '@/api/home'
import { i18n } from '@/i18n'
export default {
  name: 'PageForm',
  props: {
    title: {
      type: String,
      default: ''
    },
    fields: {
      type: Array,
      default: () => []
    },
    btnName: {
      type: String,
      default: i18n.$t('检索')
    }
  },
  data () {
    return {
      personLoading: false,
      personList: [],
      addressLoading: false,
      addressList: [],
      form: {},
      rules: {}
    }
  },
  created () {
    this.initDefault()
  },
  watch: {
    fields: {
      deep: true,
      handler () {
        this.initDefault()
      }
    }
  },
  methods: {
    personVisibleChange (e, row) {
      if (e) {
        if (row.type === 'person') {
          this.personList = []
          this.remoteMethod(row)(this.form[row.key])
        }
        if (row.type === 'address') {
          this.addressList = []
          this.addressMethod(row)(this.form[row.key])
        }
      }
    },
    addressMethod (row) {
      return (name) => {
        if (this.form[row.key] === name) {
          return
        }
        this.$set(this.form, row.key, name)
        this.addressLoading = true
        homeApi.personSearch({
          type: 'Address',
          name
        }).then(res => {
          this.addressList = res.data.map(name => {
            return {
              label: name,
              value: name
            }
          })
        }).finally(() => {
          this.addressLoading = false
        })
      }
    },
    remoteMethod (row) {
      return (name) => {
        this.$set(this.form, row.key, name)
        this.personLoading = true
        homeApi.personSearch({
          type: 'Person',
          name
        }).then(res => {
          this.personList = res.data.map(name => {
            return {
              label: name,
              value: name
            }
          })
        }).finally(() => {
          this.personLoading = false
        })
      }
    },
    initDefault () {
      let emitSearch = false
      this.fields.forEach(field => {
        Object.keys(field).forEach(attr => {
          if (Object.prototype.toString.call(field[attr]) === '[object Object]') {
            const childField = field[attr]
            if (childField.defaultValue) {
              this.$set(this.form, childField.key, childField.defaultValue)
              if (childField.key !== 'is_extension') {
                emitSearch = true
              }
            }
          }
          if (field.defaultValue) {
            this.$set(this.form, field.key, field.defaultValue)
            if (field.key !== 'is_extension') {
              emitSearch = true
            }
          }
        })
      })
      emitSearch && this.search()
    },
    search () {
      this.$emit('search', this.form)
    },
    submit () {
      this.search()
    }
  }
}
</script>
